import { useChat as useBaseChat } from '@ai-sdk/react';
import { DefaultChatTransport } from 'ai';
import { useRef } from 'react';

import { useApi } from '../../api/useApi.hook';
import { useDocumentEditor } from './useDocumentEditor.hook';

export const useAiChat = () => {
    const docEditor = useDocumentEditor();
    const { client } = useApi();
    const clientRef = useRef(client);
    clientRef.current = client;

    return useBaseChat({
        id: 'editor',
        transport: new DefaultChatTransport({
            api: `/api/v1/documents/id/${docEditor.document.documentId}/ai/generateCompletion`,
            fetch: (async (url: RequestInfo | URL, options?: RequestInit) => {
                const token = clientRef.current.getAccessToken();
                return fetch(url, {
                    ...options,
                    headers: {
                        ...(options?.headers ?? {}),
                        Authorization: `Bearer ${token}`,
                    },
                });
            }) as typeof fetch,
        })
    });
};
